import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { FiscalNumber } from "../../models/domains/pbm/fiscal-number";
import { NetworkTerm } from "../../models/domains/pbm/network-term/network-term";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { MdmBackendUrl } from "../../models/domains/urls/mdm-back-end.url";

@Injectable()
export class NetworkTermRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory
  ) {}

  public async acceptTerm(fiscalNumber: FiscalNumber, term: NetworkTerm): Promise<void> {
    const body = {
      TermKey: term.getTermKey(),
      FiscalNumber: fiscalNumber.getValue(),
      Accepted: true,
    };
    const headers = { "Content-Type": "application/json" };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      await remoteGateway.postWithHeaders(new BackendUrl("/api/network/term/accept"), body, headers);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async downloadTerm(termId: string, networkInfoKey: string): Promise<Blob> {
    try {
      const headers = { "Content-Type": "application/json" };
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data: Blob = await remoteGateway.downloadAsGet(new MdmBackendUrl("/api/mdm/term/download/" + termId + "/" + networkInfoKey), headers);
      return Promise.resolve(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
